import { Component, OnInit, Injectable, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import * as _ from 'lodash';

import { Team } from 'src/app/shared/models/team/team';
import { TeamAddComponent } from 'src/app/teams/team-add/team-add.component';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import { AuthService } from 'src/app/auth/auth.service';
declare function zE(a: string, b: string, c?: any): any;

@Component({
  selector: 'teams-nav',
  templateUrl: './teams-nav.component.html',
  styleUrls: ['./teams-nav.component.scss'],
})
@Injectable()
export class TeamsNavComponent implements OnInit {
  teams: Team[];
  errorMessage: any;
  teamQuery: string;
  dialogRef: MatDialogRef<TeamAddComponent>;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    private router: Router,
    private responsiveService: ResponsiveService
  ) {}

  ngOnInit() {}

  canAddTeam() {
    return this.authService.managerLevelAccess;
  }

  openDialog() {
    this.dialogRef = this.dialog.open(TeamAddComponent, {
      viewContainerRef: this.viewContainerRef,
    });

    this.dialogRef.afterClosed().subscribe((teamId) => {
      if (teamId) {
        this.closeMenuOnSmallScreen();
        this.router.navigate(['/teams/' + teamId]);
      }
      this.dialogRef = null;
    });
  }

  closeMenuOnSmallScreen() {
    this.responsiveService.closeMenuOnSmallScreen();
  }

  isAdmin() {
    return this.authService.adminLevelAccess;
  }

  openWidget() {
    zE('webWidget', 'helpCenter:setSuggestions', { url: true });
    zE('webWidget', 'show');
    zE('webWidget', 'open');
  }
}
